const doc = [({"ja":({"adminButtonHotelChildrenSetting":({"saveChildrenSetting":"子供設定を保存する", "saveNotesOnChildren":"注意事項を保存する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;